import { APP_NAME } from './index.js';

/**
 * The one place a page title is assembled.
 *
 * Both sides build titles: the API injects one into the shell so a crawler that never runs
 * JavaScript sees it, and the React page sets its own once it mounts. If those two disagree the
 * title visibly changes after load and a search engine can index either — so they call this.
 *
 * `pageTitle('Rise, Thunderfury!', 'Quest')` -> `Rise, Thunderfury! - Quest - Thottbot Forever`
 */
export function pageTitle(...parts: (string | null | undefined)[]): string {
  const kept = parts.filter((p): p is string => typeof p === 'string' && p.trim().length > 0);
  return [...kept, APP_NAME].join(' - ');
}
